import { useRoute as useLibRoute } from 'vue-router'

export function useRouteId() {
  const route = useLibRoute()
  const routeId = route.params.id as string

  return {
    route,
    routeId,
  }
}
